import { DeleteCenterCommentsRequest } from '../../../lib/types/models/center/center'
import { IdsInput } from '../../../lib/types/utils'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function deleteCenterLecComments(input: DeleteCenterCommentsRequest) {
  const { ids, centerId } = input
  return restApiClient
    .url(
      encodeNestedObject<IdsInput>(
        constructApiUrl(API.centers.deleteCenterLecComments.url, { centerId }),
        { ids }
      )
    )
    .delete()
}
